var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"portfolio-card"},[_c('img',{staticClass:"portfolio-card__image ",attrs:{"alt":"portfolio-card-image","src":_vm.imgUrl}})])])}
var staticRenderFns = []

export { render, staticRenderFns }